<template>
  <div v-if="mapShops && mapShops.length">
    <hooper
      class="slides-container"
      ref="carousel"
      :centerMode="true"
      :wheelControl="false"
      @beforeSlide="slideStarted"
      @slide="cardChanged"
      @afterSlide="slideFinished"
    >
      <slide v-for="shop in mapShops" :key="shop.id" class="item">
        <div class="item-wrapper" @click="shopClicked(shop.id)">
          <div
            class="item-image"
            :style="{ backgroundImage: `url('${shop.site.topImage.imageUri}')` }"
          ></div>
          <div class="item-text">
            <div class="title">{{ shop.nameKanji }}</div>
            <div class="text">{{ shop.site.genre.genre }}</div>
          </div>
        </div>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>

  <div v-else>
    <hooper
      class="slides-container"
      ref="carousel"
      :centerMode="true"
      :wheelControl="false"
      @beforeSlide="slideStarted"
      @slide="cardChanged"
      @afterSlide="slideFinished"
    >
      <slide class="item">
        <div class="item-wrapper">
          <div class="item-image"><img :src="emptyHolder" /></div>
          <div class="item-text">
            <div class="title" style="margin-top: 20px;">該当するお店はありません</div>
          </div>
        </div>
      </slide>

    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper"
import "hooper/dist/hooper.css"
import { mapActions, mapGetters } from "vuex"
import EmptyHolder from "../assets/icon-empty-holder.svg"

export default {
  data() {
    return {
      sliding: false,
      pauseEvents: false,
      emptyHolder: EmptyHolder
    }
  },

  methods: {
    cardChanged({ currentSlide }) {
      if (
        currentSlide === undefined ||
        currentSlide === null ||
        this.mapShops[currentSlide] === undefined ||
        this.pauseEvents
      ) {
        return
      }

      this.$emit("cardChanged", this.mapShops[currentSlide].id)
    },

    shopClicked(shopId) {
      if (this.sliding) {
        return
      }

      // 選択された店舗を取得
      const shop = this.mapShops.find(s => s.id === shopId)
      if (shop) {
        // DataLayerにpush（カスタムイベント）
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "shop_detail_click",   // カスタムイベント名
          shop_name: shop?.nameKanji || ''
        })
      }

      if (shopId === this.highlightedShopId) {
        this.setSelectedShopId(shopId)
      } else {
        this.$emit("cardChanged", shopId)
      }
    },

    slideStarted({ slideTo }) {
      if (!slideTo) {
        return
      }

      this.sliding = true
    },

    slideFinished({ currentSlide }) {
      this.sliding = false

      if (this.mapShops && this.mapShops.length > 0) {
        if (this.mapShops[currentSlide].id !== this.highlightedShopId) {
          this.$log.warn("carousel got out of sync, trying to fix it…")
          this.update(this.highlightedShopId)
        }
      }
    },

    update(highlightedShopId) {
      const index = this.mapShops.findIndex(shop => shop.id === highlightedShopId)

      this.$log.debug("highlightedShopIndex", index)

      if (index === null || index === undefined || index < 0) {
        this.$refs.carousel.slideTo(0)
        return
      }

      this.pauseEvents = true

      if (index !== this.$refs.carousel.currentSlide) {
        this.$refs.carousel.slideTo(index)
      }

      this.pauseEvents = false
    },

    ...mapActions("stores", ["setSelectedShopId"])
  },

  computed: {
    // itemsToShow() {
    //   const width = window.innerWidth

    //   // return 1.62e-7 * width * width + 0.005 * width + 0.1021
    //   return width / 190.0
    // },
    ...mapGetters("stores", ["mapShops", "highlightedShopId"])
  },

  watch: {
    highlightedShopId(newValue) {
      this.update(newValue)
    },

    mapShops() {
      this.update(this.highlightedShopId)
      this.$emit("getShop", this.highlightedShopId)
    }
  },

  components: {
    Hooper,
    Slide,
    HooperNavigation
  }
}
</script>

<style src="./Carousel.css" scoped></style>
